(function () {
    "use strict";

    // helpers
    // ==============
    const validExtensions = [
        ".pdf",
        ".doc",
        ".docx",
        ".xls",
        ".xlsx",
        ".csv",
        ".zip",
    ];

    const isValidLinkUrl = (url) => {
        return validExtensions.some((ext) => url.href.endsWith(ext));
    };

    // fileFormatter
    const formatFileSize = (bytes) => {
        // if no size, return blank string
        if (typeof bytes !== "number" || bytes === 0) return "";
        // if less than 1 KB, display in Bytes
        if (bytes < 1024) return `${bytes} Bytes`;
        // if less than 10 KB, display in KB
        if (bytes < 1024 * 10) return `${(bytes / 1024).toFixed(2)} KB`;
        // otherwise, prefer displaying in MB
        return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    };

    const getFileExtension = (url) => {
        const extension = url.split(".").pop().toLowerCase();
        return validExtensions.includes(`.${extension}`)
            ? extension.toUpperCase()
            : "unknown";
    };

    // fetch function to get response headers and return single object
    const fetchFileSize = async (url) => {
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    Range: "bytes=0-0",
                },
            });

            if (!response.ok && response.status !== 206) {
                // 206 is Partial Content
                throw new Error(
                    `Network response was not ok: ${response.statusText}`,
                );
            }

            let contentLength = Number(response.headers.get("content-length"));
            const contentRange = response.headers.get("content-range");

            // get headers for contentlength and content type
            if ((!contentLength || contentLength === 1) && contentRange) {
                contentLength = parseInt(contentRange.split("/")[1]);
            }

            const fileType = getFileExtension(url);

            // return object that holds the fileData
            return {
                fileSize: contentLength || 0,
                fileType: fileType || "",
            };
        } catch (error) {
            return null;
        }
    };

    const debounce = (func, wait) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    };

    const cache = new Map();

    const processLinks = async (links) => {
        const promises = Array.from(links).map(async (link) => {
            if (isValidLinkUrl(link)) {
                if (cache.has(link.href)) {
                    const fileData = cache.get(link.href);
                    link.innerHTML += ` [${fileData.fileType} ${formatFileSize(
                        fileData.fileSize,
                    )}]`;
                } else {
                    const fileData = await fetchFileSize(link.href);
                    if (fileData) {
                        cache.set(link.href, fileData);
                        link.innerHTML += ` [${
                            fileData.fileType
                        } ${formatFileSize(fileData.fileSize)}]`;
                    }
                }
            }
        });
        await Promise.all(promises);
    };

    const getLinkDetails = debounce(async () => {
        const fullDomain = `${window.location.protocol}//${window.location.hostname}`;
        const pageLinks = document.querySelectorAll(
            `a[href^="${fullDomain}"]:not([class])`,
        );
        if (pageLinks) {
            processLinks(pageLinks);
        }
    }, 300);

    document.addEventListener("DOMContentLoaded", function (event) {
        getLinkDetails();
    });
})();
